"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    borrowerConfig: finley_types_1.Organization.BorrowerConfigSchema.describe('Borrower config'),
    creditFacilityConfigs: v4_1.z
        .array(finley_types_1.Organization.CreditFacilityConfigWithSlugSchema)
        .describe('Credit facility configs'),
});
exports.nodeType = 'file_configTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'configTape';
//# sourceMappingURL=types.js.map